<template>
  <div class="card card-primary card-tabs">
    <div class="card-header p-0 pt-1">
      <ul class="nav nav-tabs" id="custom-tabs-two-tab" role="tablist">
        <li class="pt-2 px-3"><h3 class="card-title">Müşteri Detayları</h3></li>
        <li class="nav-item">
          <router-link
            tag="a"
            to="/customer-search/detail/"
            class="nav-link"
            active-class="active"
            exact
            href="#custom-tabs-two-home"
            >Özet</router-link
          >
        </li>
        <li class="nav-item">
          <router-link
            tag="a"
            active-class="active"
            to="/customer-search/detail/bonuses"
            class="nav-link"
            href="#"
            v-if="auth.CustomerBonus != null && auth.CustomerBonus.isRead"
            >Bonuslar</router-link
          >
        </li>
        <li class="nav-item">
          <router-link
            tag="a"
            active-class="active"
            to="/customer-search/detail/promotions"
            class="nav-link"
            href="#"
            v-if="
              auth.CustomerPromotion != null && auth.CustomerPromotion.isRead
            "
            >Promosyonlar</router-link
          >
        </li>
        <li class="nav-item">
          <router-link
            tag="a"
            active-class="active"
            to="/customer-search/detail/deposit-control"
            class="nav-link"
            href="#"
            v-if="
              auth.CustomerDepositControl != null &&
              auth.CustomerDepositControl.isRead
            "
            >Yatırım Kontrol</router-link
          >
        </li>

        <li class="nav-item">
          <router-link
            tag="a"
            active-class="active"
            to="/customer-search/detail/scratch"
            class="nav-link"
            href="#"
            v-if="auth.CustomerScratch != null && auth.CustomerScratch.isRead"
            >Kazıkazan</router-link
          >
        </li>
        <li class="nav-item">
          <router-link
            tag="a"
            active-class="active"
            to="/customer-search/detail/passion-flower"
            class="nav-link"
            href="#"
            v-if="
              auth.CustomerPassionFlower != null &&
              auth.CustomerPassionFlower.isRead
            "
            >Çarkıfelek</router-link
          >
        </li>
        <li class="nav-item">
          <router-link
            tag="a"
            active-class="active"
            to="/customer-search/detail/gsm-new-customer"
            class="nav-link"
            href="#"
            v-if="auth.CustomerGsmNew != null && auth.CustomerGsmNew.isRead"
            >Gsm (Yeni Üye)</router-link
          >
        </li>
        <li class="nav-item">
          <router-link
            tag="a"
            active-class="active"
            to="/customer-search/detail/suspend"
            class="nav-link"
            href="#"
            v-if="auth.CustomerSuspend != null && auth.CustomerSuspend.isRead"
            >Suspend</router-link
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            href="#custom-tabs-two-settings"
            :disabled="true"
            v-if="auth.CustomerSmsMail != null && auth.CustomerSmsMail.isRead"
            >Sms / Mail Bilgileri</a
          >
        </li>
        <li class="nav-item">
          <router-link
            tag="a"
            active-class="active"
            to="/customer-search/detail/finance"
            class="nav-link"
            href="#"
            v-if="auth.CustomerFinans != null && auth.CustomerFinans.isRead"
            >Finans İşlemleri</router-link
          >
        </li>
      </ul>
    </div>
    <div class="card-body">
      <div class="tab-content" id="custom-tabs-two-tabContent">
        <router-view :customer="customer"></router-view>
      </div>
    </div>
    <!-- /.card -->
  </div>
</template>

<script>
export default {
  props: ["customer"],
  data() {
    return {
      auth: this.$store.getters.getModules,
    };
  },
  watch: {
    "$store.getters.getModules"() {
      this.auth = this.$store.getters.getModules;
      
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/Customer/CustomerDetail.vue